// Texto en español llano de cómo quedará la cuenta en el Buró según la clave de observación (CR19).
// Fuente: Manual Buró Empresas v5 PM, «Claves de Observación» (VR, FR, UP, CL).
const fecha = (s) => (/^\d{8}$/.test(s || '') && s !== '00000000' ? `${s.slice(0, 2)}/${s.slice(2, 4)}/${s.slice(4)}` : '');
const pesos = (v) => {
  const n = Number(String(v ?? '').replace(/[,$\s]/g, ''));
  return Number.isFinite(n) && n > 0 ? `$${n.toLocaleString('en-US')}` : '';
};

export const COL_CLAVE_OBSERVACION = 3019;

export const explicacionBuro = (valores = {}) => {
  const clave = String(valores[3019] ?? '').trim().toUpperCase();
  if (!clave) return null;
  const f = fecha(String(valores[3015] ?? ''));
  const quita = pesos(valores[3018]);
  const cuando = f ? ` el ${f}` : '';
  switch (clave) {
    case 'VR':
      return {
        clave,
        texto: `Dación en pago: el cliente entregó el auto${cuando}. Cuenta cerrada con saldo en 0. ${quita
          ? `Lo que no cubrió el auto (${quita}) se reporta como quita: en su historial queda como deuda perdonada, no como pagada en su totalidad.`
          : 'El auto cubrió toda la deuda.'}`,
      };
    case 'FR':
      return {
        clave,
        texto: `Adjudicación por juicio: el auto se aplicó como garantía${cuando}. Cuenta cerrada con saldo en 0; si no cubrió toda la deuda, el saldo vencido que faltó sigue reportado.`,
      };
    case 'UP':
      return {
        clave,
        texto: 'En cobranza sin pagar: el saldo pendiente se reporta como pérdida del otorgante y la cuenta sigue abierta (sin fecha de cierre).',
      };
    case 'CL':
      return {
        clave,
        texto: `En cobranza y ya pagada${f ? ` (liquidada el ${f})` : ''}: se reporta por última vez con saldo en 0.`,
      };
    default:
      return { clave, texto: `Clave de observación ${clave}.` };
  }
};
